import Lookup from 'src/componentes/select2';

const FiltroAnexo = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/FiltroAnexoLookup"
      {...props}
    />
  );
};

export default FiltroAnexo;
